export const comments_3750243 = {"data":{"data":[],"links":{}}}